/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum PopupAssociationTypeEnum {
    ALL_PAGES = 'ALL_PAGES',
    COLLECTION_TYPE = 'COLLECTION_TYPE',
    SNIPPET = 'SNIPPET',
    PAGE = 'PAGE',
    NAMED_PAGE = 'NAMED_PAGE',
}
